import { useContext, useEffect, useState } from "react";
import {
  Button,
  Modal,
  Form,
  message,
  Select,
  Row,
  Col,
  DatePicker,
} from "antd";
import Moment from "react-moment";
import { AuthContext } from "../../../../contexts/AuthContext";
import fetchDataTrace from "../../../../services/fetchDataTrace";
import moment from "moment";
import { MdCheck } from "react-icons/md";
import postDataTrace from "../../../../services/postDataTrace";
const { Option } = Select;

export default function RescheduleBooking({
  isVisible,
  selected,
  setConfirmModal,
  refetch,
}: any) {
  const [selectedTime, setSelectedTime] = useState<any>(null);
  const [availability, setAvailability] = useState<any>(null);
  const [slotModal, setSlotModal] = useState(false);
  const [date, setDate] = useState<any>(null);
  const [form] = Form.useForm();

  const { user } = useContext(AuthContext);

  const isAdvisor = user?.role?.name === "Service Advisor" ? true : false;
  const [users, setUsers] = useState<any>([]);

  const onChangeDate = async (event: any, selectedDate: any) => {
    const currentDate = event;
    const uri = `slotdates/check?date=${currentDate}`;
    setDate(currentDate);
    setSelectedTime(null);
    const response = await fetchDataTrace({ uri });
    setAvailability(response?.payload);
  };

  const handleHideModal = () => {
    setSlotModal(false);
  };

  const handleFetchUsers = async () => {
    const uri = `users`;
    const response = await fetchDataTrace({ uri });
    setUsers(response?.payload);
  };

  const onSubmit = async () => {
    let { assignedTo } = form.getFieldsValue();
    if (isAdvisor) {
      assignedTo = user?._id;
    }

    const data = {
      date: selectedTime?.starttime,
      time: selectedTime?.starttime,
      slottime: selectedTime?._id,
    };
    const booking_id = selected._id;

    const uri = `bookings/${booking_id}/reschedule`;

    const response = await postDataTrace(data, uri);
    if (response.success) {
      message.success("Rescheduled successfully");
    } else {
      message.error("Something went wrong");
    }
    setConfirmModal(false);
    await refetch();
  };

  const hideModal = () => {
    setConfirmModal(false);
  };

  useEffect(() => {
    form.resetFields();
    setSelectedTime(null);
    setDate(null);
    handleFetchUsers();
  }, [selected]);

  return (
    <Modal
      visible={isVisible}
      title="Reschedule Booking"
      onCancel={hideModal}
      footer={[
        <Button danger key="back" onClick={hideModal}>
          Cancel
        </Button>,
        <Button
          key="submit"
          form="rescheduleBooking"
          htmlType="submit"
          type="primary"
          onSubmit={onSubmit}
        >
          Confirm
        </Button>,
      ]}
    >
      <Form
        id="rescheduleBooking"
        form={form}
        name="normal_login"
        className="login-form"
        onFinish={onSubmit}
        layout={"vertical"}
      >
        <div className="pb-4">
          <div className="flex text-black font-bold text-lg">
            VEHICLE: {selected?.title}
          </div>
          <div className="mb-4">Booking No. {selected?.bookingno}</div>
          <div className="flex justify-between items-center">
            <div className="">
              <div className="flex ">
                <span className="w-12">Date: </span>
                <Moment format="Do MMM, YYYY">{selected?.date}</Moment>
              </div>
              <div className="flex ">
                <span className="w-12">Time : </span>
                <Moment format="HH:mm A">
                  {selected?.slottime?.starttime}
                </Moment>
                <div className="mx-2">-</div>
                <Moment format="HH:mm A">{selected?.slottime?.endtime}</Moment>
              </div>
            </div>
            <div className="">To</div>
            <div className="text-green-600">
              <div className="flex ">
                <span className="w-12">Date: </span>
                {date ? <Moment format="Do MMM, YYYY">{date}</Moment> : null}
              </div>
              <div className="flex ">
                <span className="w-12">Time : </span>
                {selectedTime ? (
                  <>
                    <Moment format="HH:mm A">{selectedTime?.starttime}</Moment>
                    <div className="mx-2">-</div>
                    <Moment format="HH:mm A">{selectedTime?.endtime}</Moment>
                  </>
                ) : (
                  <>
                    <div className="w-32"></div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>

        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="date"
              label="Date"
              rules={[
                {
                  required: true,
                  message: "Please select date",
                },
              ]}
            >
              <DatePicker
                format={"Do MMM, YYYY"}
                onChange={onChangeDate}
                className="w-full"
              />
            </Form.Item>
          </Col>
          {date ? (
            <Col xs={{ span: 24 }} lg={{ span: 12 }}>
              <Form.Item
                name="time"
                label="Time"
                rules={[
                  {
                    required: false,
                    message: "Please select time",
                  },
                ]}
              >
                {selectedTime ? (
                  <div
                    className="border p-1 w-full px-2 text-black"
                    onClick={() => setSlotModal(true)}
                  >
                    {moment(selectedTime?.starttime).format("HH:mm")}
                    {" - "}
                    {moment(selectedTime?.endtime).format("HH:mm")}
                  </div>
                ) : (
                  <div
                    onClick={() => setSlotModal(true)}
                    className="border p-1 w-full px-2 text-gray-400 hover:cursor-pointer"
                  >
                    Time
                  </div>
                )}
              </Form.Item>
            </Col>
          ) : null}
        </Row>
      </Form>

      <Modal
        visible={slotModal}
        title={`Booking Slots :  ${moment(date).format("Do MMM, YYYY")}`}
        onCancel={handleHideModal}
        footer={false}
      >
        {availability?.data[0]?.slottimes?.map((slot: any, index: number) => (
          <div
            className="flex justify-between items-center border-t py-2"
            key={index}
            onClick={() => {
              setSelectedTime(slot);
              setSlotModal(false);
            }}
          >
            <div className="flex">
              <div className="mr-2">{index + 1}.</div>
              <div className="flex ml-4">
                <span style={{ color: "#323232" }}>
                  {moment(slot?.starttime).format("HH:mm")}
                </span>
                <span className="mx-4">-</span>
                <span style={{ color: "#323232" }}>
                  {moment(slot?.endtime).format("HH:mm")}
                </span>
              </div>
            </div>
            <div className="flex justify-center items-center ml-4">
              <div className="bg-gray-200 px-16 py-1 mr-4">
                <span className="text-red-600">
                  {10 - slot?.bookings?.length}
                </span>
                <span className="mx-2">Slots left</span>
              </div>
              <div className="h-8 w-8 border flex justify-center items-center">
                {selectedTime?._id === slot?._id ? (
                  <MdCheck size={15} color="green" />
                ) : null}
              </div>
            </div>
          </div>
        ))}
      </Modal>
    </Modal>
  );
}
